export const Roles = {
  FinoSupport: 'Fino Support',
  ManageUsers: 'manage-users',
};
